import client from "./client";

export function login(credentials) {
  return client()
    .post("employee/sessions", credentials)
    .then((response) => response.data.data);
}

export function register(organization) {
  return client()
    .post("employee/organizations", organization)
    .then((response) => response.data.data);
}

export function getEmployees() {
  return client()
    .get("employee/employees")
    .then((response) => response.data.data);
}

export function removeEmployee(id) {
  return client()
    .delete(`employee/employees/${id}`)
    .then((response) => response.data);
}

export function confirmEmployee(confirmationToken) {
  return client()
    .get(`employee/employees/confirmation?confirmation_token=${confirmationToken}`)
    .then((response) => response.data.data);
}

export function inviteEmployee(employee) {
  return client()
    .post("employee/employees/invitation", employee)
    .then((response) => response.data)
    .catch((error) => error.response.data);
}

export function acceptInvite(employee) {
  return client()
    .patch("employee/employees/invitation", employee)
    .then((response) => response.data.data);
}

export function getLodgings(params) {
  return client()
    .get("employee/lodgings", { params })
    .then((response) => response.data.data);
}

export function createLodging(lodging) {
  return client()
    .post("employee/lodgings", lodging)
    .then((response) => response.data.data);
}

export function updateLodging(lodging, id) {
  return client()
    .patch(`employee/lodgings/${id}`, lodging)
    .then((response) => response.data.data);
}

export function getCountries() {
  return client()
    .get("employee/countries")
    .then((response) => response.data.data);
}

export function getRegions(country_id) {
  return client()
    .get("employee/regions", { params: { country: country_id } })
    .then((response) => response.data.data);
}

export function getBookings() {
  return client()
    .get("employee/bookings")
    .then((response) => response.data.data);
}

export function createBooking(booking) {
  return client()
    .post("employee/bookings", booking)
    .then((response) => response.data.data);
}

export function updateBooking(booking, id) {
  return client()
    .patch(`employee/bookings/${id}`, booking)
    .then((response) => response.data.data);
}

export function showBooking(id) {
  return client()
    .get(`employee/bookings/${id}`)
    .then((response) => response.data.data);
}

export function getAdditionalCosts(params) {
  return client()
    .get("employee/additional_costs", { params })
    .then((response) => response.data.data);
}

export function createAdditionalCost(additional_cost) {
  return client()
    .post("employee/additional_costs", additional_cost)
    .then((response) => response.data.data);
}

export function updateAdditionalCost(additional_cost, id) {
  return client()
    .patch(`employee/additional_costs/${id}`, additional_cost)
    .then((response) => response.data.data);
}

export function getCustomers() {
  return client()
    .get("employee/customers")
    .then((response) => response.data.data);
}

export function createCustomer(customer) {
  return client()
    .post("employee/customers", customer)
    .then((response) => response.data.data);
}

export function updateCustomer(customer, id) {
  return client()
    .patch(`employee/customers/${id}`, customer)
    .then((response) => response.data.data);
}

export function getDiscounts(params) {
  return client()
    .get("employee/discounts", { params })
    .then((response) => response.data.data);
}

export function createDiscount(discount) {
  return client()
    .post("employee/discounts", discount)
    .then((response) => response.data.data);
}

export function updateDiscount(discount, id) {
  return client()
    .patch(`employee/discounts/${id}`, discount)
    .then((response) => response.data.data);
}

export function getPrices(lodging_id, start_date, end_date) {
  return client()
    .get("employee/prices", { params: { lodging: lodging_id, start_date: start_date, end_date: end_date } })
    .then((response) => response.data.data);
}

export function setPrices(start_date, end_date, amount, days, lodging_ids) {
  return client()
    .post("employee/prices", { start_date, end_date, amount, days, lodging_ids })
    .then((response) => response.data.data);
}

export function getRules(params) {
  return client()
    .get("employee/rules", { params })
    .then((response) => response.data.data);
}

export function createRule(rule) {
  return client()
    .post("employee/rules", rule)
    .then((response) => response.data.data);
}

export function updateRule(rule, id) {
  return client()
    .patch(`employee/rules/${id}`, rule)
    .then((response) => response.data.data);
}

export function getStatistics(params) {
  return client()
    .get("employee/dashboard", { params })
    .then((response) => response.data);
}

export function getProfile() {
  return client()
    .get("employee/profiles")
    .then((response) => response.data.data);
}

export function updateProfile(employee) {
  return client()
    .patch("employee/profiles", employee)
    .then((response) => response.data.data);
}
